import { ViewStateDelay } from '@common/data-models/navigation/viewstate-delay';
import { ViewStateFilter } from '@common/data-models/navigation/viewstate-filter';
import { ViewStateOptions } from '@common/data-models/navigation/viewstate-options';
import { ViewStateSequence } from '@common/data-models/navigation/viewstate-sequence';
import { ObjectTypes } from '@common/enums/object-types';
import { ViewStateFilterElevations, ViewStateFilterStates } from '@common/enums/viewstate-filter-states';
import { ViewStateTypesEnum } from '@src/suite/common/enums/viewstate-types';
import { Observable, Subject } from 'rxjs';

import { Record } from './record';

export class ViewStateRecord extends Record {
    protected PropertySubject: Subject<[string, any, any]>;
    public PropertyObservable: Observable<[string, any, any]>;

    constructor() {
        super();
        this.initialize();
        this.type = ObjectTypes.PSTVIEWSTATE;
    }

    public toJSON() {
        return Record.nomWebServicesJson.convertor.toServiceViewStateRecord(this);
    }

    public initialize() {
        this.PropertySubject = new Subject<[string, any, any]>();
        this.PropertyObservable = this.PropertySubject.asObservable();
    }

    public set(field: string, value: any) {
        if (value instanceof ViewStateOptions || value instanceof ViewStateFilter || value instanceof ViewStateSequence || value instanceof ViewStateDelay) {
            value.OnChange = (v, p) => {
                if (this.PropertySubject) this.PropertySubject.next([field, v, p]);
            };
        }
        const prev = this.get(field);
        super.set(field, value);
        if (this.PropertySubject) this.PropertySubject.next([field, value, prev]);
    }

    public get viewStateLayout(): ViewStateOptions {
        return this.getAs<ViewStateOptions>('PSTViewStateLayout');
    }
    public set viewStateLayout(value: ViewStateOptions) {
        this.set('PSTViewStateLayout', value);
    }

    public get viewStateType(): ViewStateTypesEnum {
        let res = this.getAs<number>('PSTViewStateType');
        if (typeof res === 'string') {
            res = parseInt(res);
        }
        return res;
    }
    public set viewStateType(value: ViewStateTypesEnum) {
        this.set('PSTViewStateType', value);
    }

    public get viewStateFilterState(): boolean {
        let state = this.getAs<number>('PSTViewStateFilterState', ViewStateFilterStates.Expanded);
        if (!state) state = ViewStateFilterStates.Expanded;
        if (state === ViewStateFilterStates.Expanded) return true;
        return false;
    }
    public set viewStateFilterState(value: boolean) {
        let innerVal = ViewStateFilterStates.Expanded;
        if (!value) innerVal = ViewStateFilterStates.Collapsed;
        this.set('PSTViewStateFilterState', innerVal);
    }

    public get viewStateFilterElevation(): ViewStateFilterElevations {
        return this.getAs<ViewStateFilterElevations>('PSTViewStateFilterElevation', 'side');
    }
    public set viewStateFilterElevation(value: ViewStateFilterElevations) {
        this.set('PSTViewStateFilterElevation', value);
    }
}
